import { BCMSDefaultModel, BCMSRecord, Branding, DisabledPrompt, useBCMSContext, useBCMSModal } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import UIRadioGroup, { UIRadio } from "components/custom-ui/UIRadioGroup";
import { FormContainer, FormRowView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { PrimaryButton, SecondaryButton, UINumberInput, UITextInput } from "components/ui";
import Classes, { Participant } from "model";
import { useState } from "react";
import CustomModal, { CustomModalContent } from "../..";

import "./styles.css";

export default function EntryDetailsModal(props) {
    const globalController = useBCMSContext();

    const { close } = useBCMSModal();
    const [ state, setState ] = useState({
        accountType: "Checking"
    });

    const data = props.data ?? {};
    const { 
        onParticipantsModalAddSelectedParticipantsClick,
        onAddEntryModalCancelClick
    } = data ?? {};

    const onChange = prop => value => setState(state => ({ ...state, [ prop ]: value }));
    const onSubmit = evt => {
        const newParticipant = Participant.init(state ?? {});
        const defaultParticipant = BCMSDefaultModel.participant();

        const record = BCMSDefaultModel.mergeRecords(newParticipant, defaultParticipant);
        const participant = Participant.init(record);

        participant.id = Participant.nextID();
        participant.number = participant.number.length >= 4
            ? `*${ participant.number.slice(participant.number.length - 4, participant.number.length) }`
            : `*${ participant.number }`;

        BCMSRecord.batch([
            Participant.create(participant)
        ], globalController, Classes);
        
        onParticipantsModalAddSelectedParticipantsClick([ participant ]);

        onAddEntryModalCancelClick();
        close("EntryDetailsModal");
    };

    const onClose = evt => {
        onAddEntryModalCancelClick();
        close("EntryDetailsModal");
    }

    return (
        <CustomModal className="add-entry-modal" title="Entry Details" onCloseClick={ onClose }>
            <CustomModalContent>
                <FormContainer className="small-form-width">
                    <Branding id="participant_type_abi22" value="true" default="true">
                        <FormRowView text="Participant Type">
                            <UIRadioGroup direction="horizontal" value="Standard">
                                <UIRadio label="Standard" />
                                
                                <DisabledPrompt>
                                    <UIRadio label="Child Support Payment" />
                                </DisabledPrompt>
                            </UIRadioGroup>
                        </FormRowView>
                    </Branding>

                    <FormRowView text="* Name">
                        <UITextInput value={ state.participantName } onChange={ onChange("participantName") } />
                    </FormRowView>

                    <FormRowView text="* Nickname">
                        <UITextInput value={ state.nickname } onChange={ onChange("nickname") } />
                    </FormRowView>

                    <FormRowView text="* Routing Number">
                        <UINumberInput value={ state.routing } onChange={ onChange("routing") } />
                    </FormRowView>

                    <FormRowView text="Unique Identifier">
                        <UINumberInput value={ state.uniqueID } onChange={ onChange("uniqueID") } />
                    </FormRowView>

                    <FormRowView text="* Account Number">
                        <UINumberInput value={ state.number } onChange={ onChange("number") } />
                    </FormRowView>

                    <FormRowView text="* Confirm Account Number">
                        <UINumberInput value={ state.confirmedAccountNumber } onChange={ onChange("confirmedAccountNumber") } />
                    </FormRowView>

                    <FormRowView text="* Account Type">
                        <CustomSelect value={ state.accountType } onChange={ onChange("accountType") }>
                            <CustomSelectItem value="Checking">Checking</CustomSelectItem>
                            <CustomSelectItem value="Savings">Savings</CustomSelectItem>
                            <CustomSelectItem value="Loan">Loan</CustomSelectItem>
                        </CustomSelect>
                    </FormRowView>

                    <FormRowView text="Discretionary Data">
                        <UITextInput value={ state.discretionaryData } onChange={ onChange("discretionaryData") } />
                    </FormRowView>

                    <FormButtonRow>
                        <SecondaryButton text="CANCEL" onClick={ onClose } />
                        <PrimaryButton text="SAVE" onClick={ onSubmit } />
                    </FormButtonRow>
                </FormContainer>
            </CustomModalContent>
        </CustomModal>
    );
}